module.exports = __webpack_public_path__ + "img/benefits.36da6e39.svg";